import React, { type ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { AiOutlineZoomIn } from 'react-icons/ai';
import IconAlert from '@/components/common/IconAlert';
import { showModal } from '@/app/common/reducers/simpleModal';
import { getColor } from '@/helpers/utils';
import type { StartVolumeData } from '@/app/KeywordResearch/types/googleAdsApiTypes';

type RemovedKeywordsAlertProps = {
  volumeData?: StartVolumeData | null;
};

const RemovedKeywordsAlert = ({ volumeData }: RemovedKeywordsAlertProps) => {
  const dispatch = useDispatch();

  const {
    duplicate_count = 0,
    similarity_removed_count = 0,
    normalized_count = 0
  } = volumeData ?? {};

  const items: ReactNode[] = [];

  if (duplicate_count > 0) {
    items.push(
      <>
        تکراری {duplicate_count}
        <AiOutlineZoomIn
          color={getColor('warning')}
          onClick={() => dispatch(showModal('DUPLICATE_KEYWORDS'))}
          className="cursor-pointer fs-0"
        />
      </>
    );
  }

  if (similarity_removed_count > 0) {
    items.push(
      <>
        مشابه {similarity_removed_count}
        <AiOutlineZoomIn
          color={getColor('warning')}
          onClick={() => dispatch(showModal('SIMILARITY_KEYWORDS'))}
          className="cursor-pointer fs-0"
        />
      </>
    );
  }

  if (normalized_count > 0) {
    items.push(
      <>
        نرمال‌سازی‌شده {normalized_count}
        <AiOutlineZoomIn
          color={getColor('warning')}
          onClick={() => dispatch(showModal('NORMALIZED_KEYWORDS'))}
          className="cursor-pointer fs-0"
        />
      </>
    );
  }

  if (items.length === 0) return null;

  return (
    <IconAlert variant="warning">
      برخی از کلمات{' '}
      {items.map((item, i) => (
        <React.Fragment key={i}>
          {i > 0 && (i === items.length - 1 ? ' و ' : '، ')}
          {item}
        </React.Fragment>
      ))}{' '}
      از ورودی‌های ارسالی شما توسط گوگل ادز حذف شدند.
    </IconAlert>
  );
};

export default RemovedKeywordsAlert;
